// extracted by mini-css-extract-plugin
export default {"heading":"HB-z","corrected":"IB-z","redirectVerbiageContainer":"JB-z","redirectVerbiageText":"KB-z"};